import type { CommitedClubMemberEntity } from "@/modules/boxDashboard/modules/CommitedClub/entities/commitedClubMemberEntity"
import type { HUImage } from "@/modules/types/imageTypes"

export type CommitedClubMemberModel = {
  id: string
  fullName: string
  shortName: string
  avatar: HUImage | null
  sessionsCount: number
  rank: number
}

function createCommitedClubMemberModel(entity: CommitedClubMemberEntity, rank: number): CommitedClubMemberModel {
  return {
    id: entity.id,
    fullName: entity.displayName,
    shortName: entity.shortName,
    avatar: entity.avatar,
    sessionsCount: entity.sessionsCount,
    rank,
  }
}

export function createCommitedClubBlockModel(params: { members: CommitedClubMemberEntity[] }) {
  const { members } = params

  const memberModels = members.map((entity, index) => createCommitedClubMemberModel(entity, index + 1))

  const podiumMembers = memberModels.slice(0, 3)
  const listMembers = memberModels.slice(3, 10)

  const totalCount = members.length
  const isEmpty = totalCount === 0

  return {
    podiumMembers,
    listMembers,
    isEmpty,
  }
}
